const trips = {
  table: {
    headers: {
      from: 'Ubicación de Retirada',
      to: 'Ubicación del viaje',
      seats: 'Cantidad de artículos',
      passenger: 'Nombre del destinatario',
    },
  },
};

export default trips;
